class DarVideoHero {
  constructor(root) {
    this.root = root;
    this.mainVideo = root.querySelector('[data-dar-video-main]');
    this.backgroundVideo = root.querySelector('[data-dar-video-background]');
    this.toggle = root.querySelector('[data-dar-video-toggle]');

    if (!this.mainVideo || !this.toggle) return;

    this.toggle.addEventListener('click', () => this.togglePlayback());
    this.mainVideo.addEventListener('play', () => this.setButtonState(false));
    this.mainVideo.addEventListener('pause', () => this.setButtonState(true));
    this.mainVideo.addEventListener('timeupdate', () => this.syncVideos());

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.pause();
    } else {
      this.play();
    }
  }

  syncVideos() {
    if (!this.backgroundVideo) return;
    if (Math.abs(this.mainVideo.currentTime - this.backgroundVideo.currentTime) > 0.35) {
      this.backgroundVideo.currentTime = this.mainVideo.currentTime;
    }
  }

  async play() {
    const videos = [this.mainVideo, this.backgroundVideo].filter(Boolean);
    try {
      await Promise.all(videos.map((video) => video.play()));
      this.setButtonState(false);
    } catch (error) {
      this.setButtonState(true);
    }
  }

  pause() {
    [this.mainVideo, this.backgroundVideo].filter(Boolean).forEach((video) => video.pause());
    this.setButtonState(true);
  }

  togglePlayback() {
    if (this.mainVideo.paused) {
      this.play();
    } else {
      this.pause();
    }
  }

  setButtonState(isPaused) {
    this.toggle.setAttribute('aria-pressed', String(isPaused));
    this.toggle.setAttribute('aria-label', isPaused ? 'Pornește videoclipul' : 'Oprește videoclipul');
  }
}

const initDarVideoHeroes = (scope = document) => {
  scope.querySelectorAll('[data-dar-video-hero]').forEach((root) => {
    if (!root.dataset.darVideoReady) {
      root.dataset.darVideoReady = 'true';
      new DarVideoHero(root);
    }
  });
};

document.addEventListener('DOMContentLoaded', () => initDarVideoHeroes());
document.addEventListener('shopify:section:load', (event) => initDarVideoHeroes(event.target));
